/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommerceModeEnum } from './commerceModeEnum';


export interface VcdsDisconnectedDeploymentCommerceHistory { 
    expiry_date?: Date;
    mode?: CommerceModeEnum;
    quantity?: number;
    /**
     * Change timestamp
     */
    timestamp?: Date;
}
export namespace VcdsDisconnectedDeploymentCommerceHistory {
}


